module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.electorateName) ? _c('div', {
    staticClass: "drawer",
    class: {
      closed: !_vm.openDrawer
    }
  }, [_c('div', {
    staticClass: "top",
    class: {
      hide: !_vm.openDrawer
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    on: {
      "click": function($event) {
        _vm.handleDrawer(false)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "top closed",
    class: {
      hide: _vm.openDrawer
    },
    on: {
      "click": function($event) {
        _vm.handleDrawer(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrapper",
    class: {
      hide: !_vm.openDrawer
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v(_vm._s(_vm.electorateName))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "details"
  }, [_c('img', {
    staticStyle: {
      "object-fit": "cover",
      "max-height": "150px"
    },
    attrs: {
      "src": _vm.speciesData.picture.fields.file.url,
      "alt": "species image"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "max-height": "150px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.speciesData.fact) + "\n        ")])]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.learnMore
    }
  }, [_vm._v("Learn more")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e654a6c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/threatened-species/Drawer.vue
// module id = 794
// module chunks = 0